import { DateTime } from 'luxon';

export const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getTimezoneOffset = (timezone: string) => {
  const now = DateTime.now().setZone(timezone);
  const hours = Math.floor(now.offset / 60);
  const minutes = Math.abs(now.offset % 60);
  const sign = now.offset >= 0 ? '+' : '-';
  return `UTC${sign}${String(Math.abs(hours)).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
